import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';

import { useTest, useUnit } from 'hooks/units/index';
import {
  COURSE_STATUS,
  SECURITY_TYPE,
  STATUS_FILES_UNIT,
  UNIT_TYPE,
  USER_ROLES,
} from 'constants/constants';
import InputPasswordToggle from 'components/CustomInput/InputPasswordToggle';
import VideoCapture from 'components/VideoCapture/VideoCapture';

import { handleToastError } from 'helpers/index';
import useI18n from 'hooks/use-i18n';

import styles from 'styles/Unit.module.scss';
import { useSelector } from 'react-redux';
import { getColor, getColorText, getThemeColor } from 'store/settings';
import moment from 'moment';
import { getViewMode } from 'store/auth';
import { formatDDMMYYYYHHMM } from 'helpers/format-time';
import { accessDenied } from 'modules/Course/CourseDetail/optimizedDetailPage/lesson-access-modal';

const StartTest = ({ onStartTest }) => {
  const i18n = useI18n();
  const unitSelected = useUnit();
  const test = useTest();
  const [error, setError] = useState('');
  const [photo, setPhoto] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const viewMode = useSelector(getViewMode);
  const security = unitSelected?.config?.security;
  //Color Theme
  const colorStatus = useSelector(getColor);
  const colorTextStatus = useSelector(getColorText);
  const themeStatus = useSelector(getThemeColor);

  //DisableConditon
  let isDisabled = unitSelected?.status == COURSE_STATUS.INACTIVE;

  const now = moment();
  const isAfterDate =
    viewMode === USER_ROLES.LEARNER &&
    unitSelected?.time?.end &&
    now.isAfter(moment(unitSelected?.time?.end));

  const renderSecurity = () => {
    if (security === SECURITY_TYPE.PASSWORD) {
      return (
        <>
          <p>
            This test is password protected. Please enter the password below to
            continue.
          </p>
          <InputPasswordToggle
            id="password"
            autocomplete="new-password"
            className={styles.inputPassword}
          />
        </>
      );
    }

    return (
      <div className="mb-2">
        <VideoCapture photo={photo} setPhoto={setPhoto} />
      </div>
    );
  };

  const handleScheduleMeet = (time, type) => {
    accessDenied(
      `This lesson will be accessible at the scheduled time. <br />
           Start Date: <strong> ${formatDDMMYYYYHHMM(time?.begin)} </strong> ${
        time?.due && type !== UNIT_TYPE.LIVESTREAMING
          ? `| Due Date: <strong> ${formatDDMMYYYYHHMM(time?.due)} </strong>`
          : ''
      }   | End Date: <strong>  ${formatDDMMYYYYHHMM(time?.end)} </strong> `,
      {
        confirmButtonColor: themeStatus,
      },
    );
  };

  const checkStartTest = async () => {
    try {
      const mainType = unitSelected?.type;
      const statusFile = unitSelected?.statusFile;
      const isLiving = unitSelected?.isLiving;
      const isAssignment =
        mainType === UNIT_TYPE.ASSIGNMENT &&
        statusFile === STATUS_FILES_UNIT.UPCOMING;

      const startDate = moment(unitSelected?.time?.begin);
      const now = moment();

      const IsBefore = now.isBefore(startDate);

      if (
        mainType == UNIT_TYPE.LIVESTREAMING
          ? unitSelected?.restrictAccess
          : true
      ) {
        if (
          (mainType == UNIT_TYPE.LIVESTREAMING ? !isLiving : true) &&
          viewMode === USER_ROLES.LEARNER &&
          (isAssignment || IsBefore)
        ) {
          handleScheduleMeet(unitSelected?.time, mainType);
          return null;
        }
      }
      setIsLoading(true);
      if (security === SECURITY_TYPE.PASSWORD) {
        const passwordElm = document.getElementById('password');
        const passwordValue = passwordElm.value;

        if (!passwordValue) {
          setIsLoading(false);
          return setError('Please input password');
        }
      }
      await onStartTest();
    } catch (e) {
      setIsLoading(false);
      handleToastError(e, i18n);
    }
  };

  if (isAfterDate) {
    return (
      <p style={{ color: 'rgb(252, 52, 52)' }} className="text-center">
        This lesson expired on{' '}
        <strong>
          {moment(unitSelected?.time?.end).format('MMMM Do YYYY, h:mm A')}
        </strong>{' '}
      </p>
    );
  }

  return (
    <div>
      {security && renderSecurity()}
      {error && <p className="message-error">{error}</p>}
      {(security === SECURITY_TYPE.SNAPSHOT ? photo : true) && (
        <button
          className="btn-bg-color"
          onClick={checkStartTest}
          disabled={
            isDisabled ||
            test?.isLoading ||
            (security === SECURITY_TYPE.SNAPSHOT && !photo) ||
            isLoading
          }
          style={{
            backgroundColor: `${colorStatus}`,
            color: `${colorTextStatus}`,
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = 'white';
            e.target.style.borderColor = colorStatus;
            e.target.style.color = colorStatus;
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = colorStatus;
            e.target.style.color = colorTextStatus;
          }}
        >
          Start
        </button>
      )}
    </div>
  );
};

StartTest.propTypes = {
  onStartTest: PropTypes.func.isRequired,
};

export default StartTest;
